import { Box, Grid, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { setUnderConstruction } from "../../AppSlice";

export function Maintenance() {
  const translation = useAppSelector(selectText);
  const dispatch = useAppDispatch();
  return (
    <Grid container component="main" justifyContent="flex-end" sx={{ height: "100%" }}>
      <Grid
        item
        xl={12}
        sx={{
          backgroundColor: "white",
          textAlign: "center",
          pedding: 10,
        }}
      >
        {translation.paneem_not_availble.map((text, i) => {
          return (
            <Typography key={i} sx={{ fontSize: 30, textAlign: "center", margin: 5 }}>
              {text}
            </Typography>
          );
        })}

        <Box
          component="img"
          src="/images/underconstruction-01.svg"
          alt="icon"
          // onClick={() => dispatch(setUnderConstruction())}
          sx={{
            backgroundColor: "white",
            width: "10%",
            margin: 15,
            color: "red",
          }}
        />
      </Grid>
    </Grid>
  );
}
